export const PROVIDE_KEY = "vue-use-query-param";
